import React from 'react';
import { Form, Radio, Select, Checkbox } from 'antd';
import { FormItemProps } from 'antd/lib/form';
import { OptionItem } from 'interfaces/OptionItem';
import styled from '@emotion/styled';

type SelectType = 'radio' | 'radiobutton' | 'checkbox' | 'multiple' | 'tags' | 'searchable';

type FormItemProps2 = Omit<FormItemProps, 'children'>;
interface FormSelectProps extends FormItemProps2 {
  name?: string;
  label?: string;
  placeholder?: string;
  type?: SelectType;
  options?: OptionItem[];
  disabled?: boolean;
  allowClear?: boolean;
  hidden?: boolean;
  onChange?: (value: any) => void;
  onSearch?: (value: string) => void;
}

export const FormSelect: React.FC<FormSelectProps> = ({ type, options, disabled, allowClear, onChange, onSearch, ...props }) => {
  const placeholder = props.placeholder || props.label;
  const selectVisibleItems = 5;
  const listHeight = selectVisibleItems * 32;
  const selectProps: Partial<any> = {
    className: 'form-select',
    placeholder,
    disabled,
    listHeight,
    allowClear,
  };

  const filterOption = (input: string, option: any) => {
    const optionLow = option.label.toLowerCase();
    return (optionLow.indexOf(input.toLowerCase()) >= 0);
  };

  const onSelectChange = (value: any) => {
    onChange && onChange(value);
  };

  const renderControl = (controlType?: SelectType) => {
    switch (controlType) {
      case 'checkbox':
        return (
          <CheckboxGroup disabled={disabled}>
            {options?.map((op, idx) =>
              <Checkbox key={idx} value={op.value} disabled={op.disabled}>
                {op.label}
              </Checkbox>
            )}
          </CheckboxGroup>
        );
      case 'radio':
        return (
          <Radio.Group disabled={disabled}>
            {options?.map((op, idx) =>
              <Radio key={idx} value={op.value}>{op.label}</Radio>
            )}
          </Radio.Group>
        );
      case 'radiobutton':
        return (
          <RadioGroup disabled={disabled}>
            {options?.map((op, idx) =>
              <Radio.Button key={idx} value={op.value}>{op.label}</Radio.Button>
            )}
          </RadioGroup>
        );
      case 'multiple':
        return (
          <Select options={options} {...selectProps} mode='multiple' allowClear showSearch={false} onChange={onSelectChange} />
        );
      case 'tags':
        return (
          <Select options={options} {...selectProps} mode='tags' tokenSeparators={[',']} allowClear onChange={onSelectChange} />
        );
      case 'searchable':
        return (
          <Select options={options} {...selectProps} showSearch onSearch={onSearch} filterOption={filterOption} onChange={onSelectChange} />
        );
      default:
        return (
          <Select options={options} {...selectProps} onChange={onSelectChange} />
        );
    }
  };

  return (
    <Form.Item {...props}>
      {renderControl(type)}
    </Form.Item>
  );
};

const CheckboxGroup = styled(Checkbox.Group)`
  margin: 5px 0;
  & .ant-checkbox-wrapper {
    margin-left: 0px;
    margin-right: 8px;
  }
`;

const RadioGroup = styled(Radio.Group)`
  width: 100%;
  display: flex;
  & > .ant-radio-button-wrapper {
    flex: 1;
    text-align: center;
  }
`;
